import { atom } from 'jotai'

import { type ModalKeys, type ModalProps } from './types'

type ModalState = { key: ModalKeys; props: ModalProps[ModalKeys] } | null

export const openModalAtom = atom<ModalState>(null)
